// extracted by mini-css-extract-plugin
export default {"searchBox":"SearchBar_searchBox__R4yCi","searchInput":"SearchBar_searchInput__Ql+wC"};